import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";

export function useDisconnectIdentity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (provider: string) => api.delete(`me/identities/${provider}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
}
